import moment from 'moment';
import _ from 'lodash';
import { initVisitor } from '@meiqia/utils';

import { parseQueryStringObj } from '../parse-url';

const updateSortFlag = client => {
  client.last_msg_created_on = client.last_msg_created_on || 0;
};

/**
 * 从着陆页中初始化 utm 信息
 */
function initUtm(page) {
  let queryData = parseQueryStringObj(page);
  return {
    utm_source: queryData.utm_source,
    utm_medium: queryData.utm_medium,
    utm_term: queryData.utm_term,
    utm_content: queryData.utm_content,
    utm_campaign: queryData.utm_campaign
  };
}

const updateHistoryClient = con => {
  const visit_info = con.visit_info;

  if (visit_info) {
    con.location = (visit_info.province || '') + (visit_info.city || '');
    con.ip = visit_info.ip;
    con.browser = visit_info.browser_family;
    con.os = visit_info.os_family + visit_info.os_version_string;
    con.visit_page_cnt = visit_info.visit_page_cnt;
    con.visit_page_accu_time = visit_info.visit_page_accu_time;
    con.name = visit_info.name || con.name || `${con.location} #${con.id}`;
  }
  con.agent_msg_num = con.msg_num - con.client_msg_num;

  return con;
};

export const generateClient = (clientObj = {}, clientType = 'chat') => {
  const client = { ...clientObj };
  if (!client.visit_info) {
    client.visit_info = {};
  }
  client.conversation_id = client.id;
  client.name =
    client.visit_info.name || `${client.visit_info.province || ''}${client.visit_info.city || ''} #${client.id}`;

  client.last_msg_created_on = moment.utc(client.last_msg_created_on || client.last_updated).valueOf();
  client.last_msg_content = client.last_msg_content || '';

  updateSortFlag(client);

  if (_.isEmpty(client.attrs)) {
    client.attrs = {};
  }

  if (_.isEmpty(client.customAttrs)) {
    client.customAttrs = {};
  }
  if (_.isEmpty(client.tags)) {
    client.tags = [];
  }
  // 加上 sourceInfo 和 avatar
  client.visit_info = initVisitor(client.visit_info);
  // decode url
  if (client.visit_info) {
    try {
      client.url && (client.url = decodeURIComponent(client.url));
    } catch (e) {
      console.log('decodeURIComponent error:', client.url);
    }

    try {
      client.visit_info.first_visit_page_source_url_by_session &&
        (client.visit_info.first_visit_page_source_url_by_session = decodeURIComponent(
          client.visit_info.first_visit_page_source_url_by_session
        ));
    } catch (e) {
      console.log('decodeURIComponent error:', client.visit_info.first_visit_page_source_url_by_session);
    }

    client.visit_info.utm = {};
    try {
      client.visit_info.first_visit_page_url_by_session &&
        (client.visit_info.first_visit_page_url_by_session = decodeURIComponent(
          client.visit_info.first_visit_page_url_by_session
        ));
      client.visit_info.first_visit_page_url_by_session &&
        (client.visit_info.utm = initUtm(client.visit_info.first_visit_page_url_by_session));
    } catch (e) {
      console.log('decodeURIComponent error:', client.visit_info.first_visit_page_url_by_session);
    }

    try {
      client.visit_info.first_visit_page_url_by_session &&
        (client.visit_info.first_visit_page_url_by_session = decodeURIComponent(
          client.visit_info.first_visit_page_url_by_session
        ));
    } catch (e) {
      console.log('decodeURIComponent error:', client.visit_info.first_visit_page_url_by_session);
    }

    // 处理神马搜索
    if (client.visit_info.first_visit_page_source_by_session === 'sm.cn') {
      client.visit_info.first_visit_page_source_by_session = 'sm';
    }
  }

  client.receiveConvId = client.id;
  if (clientType === 'history') {
    updateHistoryClient(client);
  }

  // 输入框的状态，分为消息：message，内部消息：internalMessage，发送到邮箱：email，发送到应用：sdk
  client.editMode = 'message';

  if (clientType === 'history') {
    client.first_agent_response_wait_time = 0;
    if (client.first_msg_created_on) {
      // 第一条消息是顾客发的
      if (client.first_msg_created_on === client.client_first_send_time) {
        // 真实的有客服消息
        if (client.agent_effective_msg_num > 0) {
          client.first_agent_response_wait_time =
            parseInt(moment(client.client_first_send_time).valueOf() / 1000) -
            parseInt(moment(client.created_on).valueOf() / 1000) +
            (client.first_response_wait_time || 0);
        }
        // 第一条消息是客服发的
      } else {
        client.first_agent_response_wait_time =
          parseInt(moment(client.first_msg_created_on).valueOf() / 1000) -
          parseInt(moment(client.created_on).valueOf() / 1000);
      }
    }
  }
  return client;
};

export default {
  generateClient
};
